import IntroImage from 'assets/images/intro-pages/motor-liability-insurance.jpg';
import { FlowsIntroLayout } from 'components/flows/common/FlowsIntroLayout/FlowsIntroLayout';
import { Content } from 'components/flows/motorLiabilityInsurance/IntroPage/Content';
import { useTranslation } from 'react-i18next';

export const MotorLiabilityInsuranceIntroPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <FlowsIntroLayout introImage={IntroImage} navigationText={t('flows.header.navigation.motorLiabilityInsurance')}>
      <Content />
    </FlowsIntroLayout>
  );
};
